import React from 'react'
import { ReactComponent as QrCodeInactiveSvg } from './QrCodeInactiveIcon.svg'

// Too large / specific to go into the transfix-icons folder
export const QrCodeInactive = () => {
  return <QrCodeInactiveSvg />
}

export default QrCodeInactive
